import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="relative py-28 px-4 sm:px-6 lg:px-8 bg-zinc-950 overflow-hidden" data-id="element-27">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-zinc-900 via-amber-500/30 to-zinc-900" data-id="element-28"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-30">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-zinc-100" data-id="element-31">
            Get in Touch
          </h2>
          <p className="text-xl text-zinc-400 mb-12 max-w-2xl mx-auto font-light" data-id="element-32">
            Available for professional consultations, media strategy
            discussions, and strategic communication planning.
          </p>

          <div className="flex items-center justify-center gap-2 text-amber-500/90 mb-12 font-serif text-lg" data-id="element-33">
            <MapPin className="w-5 h-5" data-id="element-34" />
            <span data-id="element-35">Based in Uttar Pradesh, India</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16 mb-16" data-id="element-36">
            <a href="tel:+918795922220" className="flex items-center gap-4 text-xl text-zinc-300 hover:text-amber-500 transition-all group" data-id="element-37">
              <div className="w-14 h-14 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-amber-500/50 group-hover:bg-amber-500/10 transition-all shadow-lg" data-id="element-38">
                <Phone className="w-6 h-6" data-id="element-39" />
              </div>
              <span className="font-serif tracking-wide" data-id="element-40">+91 87959 22220</span>
            </a>

            <a href="tel:+919415630565" className="flex items-center gap-4 text-xl text-zinc-300 hover:text-amber-500 transition-all group" data-id="element-41">
              <div className="w-14 h-14 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-amber-500/50 group-hover:bg-amber-500/10 transition-all shadow-lg" data-id="element-42">
                <Phone className="w-6 h-6" data-id="element-43" />
              </div>
              <span className="font-serif tracking-wide" data-id="element-44">+91 94156 30565</span>
            </a>
          </div>

          <a href="tel:+918795922220" className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-zinc-950 bg-gradient-to-r from-amber-400 to-amber-600 rounded-full hover:from-amber-300 hover:to-amber-500 transition-all shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] transform hover:-translate-y-1" data-id="element-45">
            Schedule a Consultation
          </a>
        </motion.div>
      </div>

      <div className="mt-32 pt-8 border-t border-zinc-900 text-center text-zinc-600 text-sm font-light tracking-wider uppercase" data-id="element-46">
        <p data-id="element-47">© {new Date().getFullYear()} Dinesh Singh. All rights reserved.</p>
      </div>
    </section>;
}